// extracted by mini-css-extract-plugin
export default {"footer":"FooterContent_footer__10Uri","cancelWithStatusSelect":"FooterContent_cancelWithStatusSelect__BAN7Z"};